import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, APP_INITIALIZER } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { LoginPageModule } from './features/login/login-page.module';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material/material/material.module';
import { TemplateComponent } from './shared/layout/template/template.component';
import { SidenavComponent } from './shared/layout/sidenav/sidenav.component';
import { HeaderComponent } from './shared/layout/header/header.component';
import { ChangePassComponent } from './features/change-pass/change-pass.component';
// import { DashboardComponent } from './features/dashboard/dashboard/dashboard.component';
import { TransactionsComponent } from './features/transactions/transactions/transactions.component';
import { AllTransactionComponent } from './features/transactions/all-transaction/all-transaction.component';
import { BuyLoadComponent } from './features/transactions/buy-load/buy-load.component';
import { CashInComponent } from './features/transactions/cash-in/cash-in.component';
import { PayBillsComponent } from './features/transactions/pay-bills/pay-bills.component';
import { TransferFundsComponent } from './features/transactions/transfer-funds/transfer-funds.component';
import { StorePurchaseComponent } from './features/transactions/store-purchase/store-purchase.component';
import { MegaRewardComponent } from './features/transactions/mega-reward/mega-reward.component';
import { PromoComponent } from './features/transactions/promo/promo.component';
import { OverviewComponent } from './features/transactions/overview/overview.component';
import { AccountsComponent } from './features/accounts/accounts/accounts.component';
import { AccountViewComponent } from './features/accounts/account-view/account-view.component';
import { AccountsInformationComponent } from './shared/component/accounts-information/accounts-information.component';
import { AccountsKycDetailComponent } from './shared/component/accounts-kyc-detail/accounts-kyc-detail.component';
import { AccountsEditComponent } from './features/accounts/accounts-edit/accounts-edit.component';
import { KycComponent } from './features/kyc/kyc/kyc.component';
import { KycRegistrationComponent } from './features/kyc/kyc-registration/kyc-registration.component';
import { KycLogsComponent } from './features/kyc/kyc-logs/kyc-logs.component';
import { MegapayFeaturesComponent } from './features/features/features/megapay-features/megapay-features.component';
import { FeaturesBillerComponent } from './features/features/features-biller/features-biller.component';
import { SkuBillerAllTransactionComponent } from './features/features/biller-dashboard/sku-biller-all-transaction/sku-biller-all-transaction.component';
import { SkuPayBillsComponent } from './features/features/sku-paybills/sku-pay-bills/sku-pay-bills.component';
import { SkuStoresComponent } from './features/features/sku-stores/sku-stores.component';
import { SkuRedeemComponent } from './features/features/sku-redeem/sku-redeem.component';
import { FeaturesPushNotifComponent } from './features/features/push-notification/features-push-notif/features-push-notif.component';
import { FeaturesAnnouncementComponent } from './features/features/announcement/announcement/features-announcement.component';
import { FeaturesProfanityFilterComponent } from './features/features/features-profanity-filter/features-profanity-filter.component';
import { FeaturesAutoDisableLogsComponent } from './features/features/features-auto-disable-logs/features-auto-disable-logs.component';
import { FeaturesRdpdDashboardComponent } from './features/features/features-rdpd-dashboard/features-rdpd-dashboard.component';
import { FeaturesReferalComponent } from './features/features/features-referal/features-referal.component';
import { CashinOutComponent } from './features/cashin-out/cashin-out.component';
// import { CashInTransactionComponent } from './features/cash-in-transaction/cash-in-transaction.component';
import { CashInTransactionLogsComponent } from './features/cash-in-transaction-logs/cash-in-transaction-logs.component';
import { CashOutTransactionComponent } from './features/cash-out-transaction/cash-out-transaction.component';
import { AdminComponent } from './features/admin/admin/admin.component';
import { AdminBuyloadComponent } from './features/admin/admin-buyload/admin-buyload.component';
import { AdminTpLogsComponent } from './features/admin/admin-tp-logs/admin-tp-logs.component';
import { AdminTpPayBillsComponent } from './features/admin/admin-tp-pay-bills/admin-tp-pay-bills.component';
import { AdminTpCashInComponent } from './features/admin/admin-tp-cash-in/admin-tp-cash-in.component';
import { AdminTpStoresComponent } from './features/admin/admin-tp-stores/admin-tp-stores.component';
import { AdminTpRedeemComponent } from './features/admin/admin-tp-redeem/admin-tp-redeem.component';
import { KycFormComponent } from './features/kyc/kyc-form/kyc-form.component';
import { ModalComponent } from './shared/component/confirmation-modal/confirmation_modal.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  MAT_MOMENT_DATE_FORMATS, MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import {
  DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE  } from '@angular/material/core';
import * as moment from 'moment';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { NgxSpinnerModule } from "ngx-spinner";

// import { AdminPortalCreateAccountComponent } from './component/admin-portal-create-account/admin-portal-create-account.component';
// import { AdminPortalModifyAccountComponent } from './component/admin-portal-modify-account/admin-portal-modify-account.component';
import { Ng2SearchPipeModule} from 'ng2-search-filter';
// import { NgxPaginationModule} from'ngx-pagination';
import { CurrencyPipe} from '@angular/common';
import { DecimalPipe} from '@angular/common';
import { DatePipe } from "@angular/common";
import { TitleCasePipe } from "@angular/common";
import { MatDialogModule } from '@angular/material/dialog';
import { MatConfirmDialogComponent } from './shared/component/mat-confirm-dialog/mat-confirm-dialog.component';
import { FeaturesAnnouncementEditComponent } from './features/features/announcement/announcement-edit/features-announcement-edit.component';
import { SkuPaybillsEditComponent } from './features/features/sku-paybills/sku-paybills-edit/sku-paybills-edit.component';
import { SkuStoresEditComponent } from './features/features/biller-dashboard/sku-stores-edit/sku-stores-edit.component';
import { AdminPortalAccountsComponent } from './features/admin/admin-portal-accounts/admin-portal-accounts.component';
import { AdminPortalCreateAccountComponent } from './features/admin/admin-portal-create-account-old/admin-portal-create-account.component';
import { AdminPortalModifyAccountComponent } from './features/admin/admin-portal-modify-account-old/admin-portal-modify-account.component';
import { SearchFilterPipe } from './search-filter.pipe';
import { AdminPortalUserLogsComponent } from './features/admin/admin-portal-user-logs/admin-portal-user-logs.component';
import { ReportsBranchComissionComponent } from './features/reports/reports-branch-comission/reports-branch-comission.component';
import { ReportsSummaryComponent } from './features/reports/reports-summary/reports-summary.component';
import { ReportsTopUserComponent } from './features/reports/reports-top-user/reports-top-user.component';
import { ReportsComponent } from './features/reports/reports/reports.component';
import { ReportsDailySalesComponent } from './features/reports/reports-daily-sales/reports-daily-sales.component';
import { ReportsReferalComissionComponent } from './features/reports/reports-referal-comission/reports-referal-comission.component';
import { SkuCashInComponent } from './features/features/sku-cash-in/sku-cash-in.component';
import { CustomCategoryComponent } from './shared/component/custom-category/custom-category.component';
// import { AccountsSearchComponent } from './component/accounts-search/accounts-search.component';
// import { AdminPortalAccountsExpandComponent } from './component/admin-portal-accounts-expand/admin-portal-accounts-expand.component';
// import { ExpansionComponent } from './component/expansion/expansion.component';
// import { AdminPortalUserLogsComponent } from './component/admin-portal-user-logs/admin-portal-user-logs.component';
// import { ReportsSummaryComponent } from './component/reports-summary/reports-summary.component';
// import { ReportsDailySalesComponent } from './component/reports-daily-sales/reports-daily-sales.component';
// import { ReportsTopUserComponent } from './component/reports-top-user/reports-top-user.component';
// import { ReportsReferalComissionComponent } from './component/reports-referal-comission/reports-referal-comission.component';
// import { ReportsBranchComissionComponent } from './component/reports-branch-comission/reports-branch-comission.component';
// import { ReportsComponent } from './component/reports/reports.component';
// import { AdminPortalAccountsComponent } from './component/admin-portal-accounts/admin-portal-accounts.component';
// import { FeaturesAnnouncementEditComponent } from './component/features-announcement-edit/features-announcement-edit.component';
// import { ForTESTComponent } from './for-test/for-test.component';
// import { ComponentSkuBillerAllTransactionEditComponent } from './component/component-sku-biller-all-transaction-edit/component-sku-biller-all-transaction-edit.component';
// import { SkuBillerAllTransactionEditComponent } from './component/sku-biller-all-transaction-edit/sku-biller-all-transaction-edit.component';
// import { SkuStoresEditComponent } from './component/sku-stores-edit/sku-stores-edit.component';
// import { SkuPaybillsEditComponent } from './component/sku-paybills-edit/sku-paybills-edit.component';
import { SkuCashInEditComponent } from './features/features/sku-cash-in-edit/sku-cash-in-edit.component';
import { SendPassComponent } from './features/send-pass/send-pass.component';
import { SharedPipeModule } from './shared/modules/shared-pipe.module';
import { SharedDirectivesModule } from './shared/modules/shared-directives.module';
import { DropdownFieldComponent } from './shared/component/custom-dropdown/custom-dropdown.component';
import { CustomToggleAddBtnComponent } from './shared/component/custom-toggle-add-btn/custom-toggle-add-btn.component';
import { PaginationComponent } from './shared/component/pagination/pagination.component';
import { TableControlsComponent } from './shared/component/table-controls/table-controls.component';
import { LimitControlComponent } from './shared/component/limit-control/limit-control.component';
import { SearchControlComponent } from './shared/component/search-control/search-control.component';
import { DropdownChecklistComponent } from './shared/component/dropdown-checkbox/dropdown-checkbox.component';
import { ActionDialogComponent } from './shared/component/action-dialog/action-dialog.component';
import { ToggleableComponent } from './shared/component/toggleable-button/toggleable-button.component';
import { MegapayLoaderComponent } from './shared/component/megapay-loader/megapay-loader.component';
import { FeaturesPushNotifEditComponent } from './features/features/push-notification/feature-push-notif-edit/feature-push-notif-edit.component';
import { SharedComponentsModule } from './shared/modules/shared-component.module';
import { ImagePreviewDialogComponent } from './shared/component/image-view-preview-dialog/image-view-preview-dialog.component';
import { DateInputComponent } from './shared/component/date-input/date-input.component';
import { AuthInterceptor } from './auth.interceptor';
import { ViewReferalComponent } from './features/features/features-referal/view-referal/view-referal.component';
import { AdminPortalAccountModalComponent } from './features/admin/admin-portal-accounts/portal-account-modal/portal-account-modal.component';
import { AdminPortalAccountsOldComponent } from './features/admin/admin-portal-accounts-old/admin-portal-accounts-old.component';
import { DropdownFieldV2Component } from './shared/component/custom-dropdown-v2/custom-dropdown-v2.component';
import { DropdownChecklistV2Component } from './shared/component/dropdown-checkbox-v2/dropdown-checkbox-v2.component';
import { FeaturesByTiersComponent } from './features/admin/system-maintainance/features-by-tiers/features-by-tiers.component';
import { ModifyTierModalComponent } from './features/admin/system-maintainance/features-by-tiers/modify-tier-modal/modify-tier-modal.component';
import { AddDistributorComponent } from './features/features/features-rdpd-dashboard/add-distributor/add-distributor.component';
import { ViewDistributorsComponent } from './features/features/features-rdpd-dashboard/view-distributors/view-distributors.component';
import { CreateEditSkuModalComponent } from './features/features/biller-dashboard/sku-biller-all-transaction/create-edit-sku-modal/create-edit-sku-modal.component';
import { IdleWatcherService } from './services/idle-watcher.service';
import { UserStatusCheckerService } from './services/user-status-checker.service';
import { AuthService } from './core/services/auth.service';
import { AppMaintainanceComponent } from './features/admin/system-maintainance/app-maintainance/app-maintainance.component';
import { AccessDeniedComponent } from './features/access-denied/access-denied.component';
import { RbacService } from './services/rbac.service';
import { AdsDashboardComponent } from './features/features/ads/ads-dashboard/ads-dashboard.component';
import { CreateEditAdsModalComponent } from './features/features/ads/create-edit-ads-modal/create-edit-ads-modal.component';
import { SkuDisbursementComponent } from './features/features/sku-disbursement/sku-disbursement.component';

@NgModule({ declarations: [
        AppComponent,
        ChangePassComponent,
        // DashboardComponent,
        TransactionsComponent,
        BuyLoadComponent,
        CashInComponent,
        PayBillsComponent,
        // MegaRewardComponent,
        PromoComponent,
        // OverviewComponent,
        AccountViewComponent,
        AccountsInformationComponent,
        AccountsKycDetailComponent,
        KycComponent,
        KycRegistrationComponent,
        KycLogsComponent,
        FeaturesBillerComponent,
        MegapayFeaturesComponent,
        SkuBillerAllTransactionComponent,
        SkuPayBillsComponent,
        FeaturesPushNotifComponent,
        FeaturesAnnouncementComponent,
        AdsDashboardComponent,
        FeaturesProfanityFilterComponent,
        FeaturesAutoDisableLogsComponent,
        FeaturesReferalComponent,
        CashinOutComponent,
        // CashInTransactionComponent,
        CashInTransactionLogsComponent,
        CashOutTransactionComponent,
        AdminComponent,
        AdminTpLogsComponent,
        // AdminTpPayBillsComponent,
        // AdminTpCashInComponent,
        // AdminTpStoresComponent,
        // AdminTpRedeemComponent,
        KycFormComponent,
        ModalComponent,
        // AdminPortalCreateAccountComponent,
        // AdminPortalModifyAccountComponent,
        MatConfirmDialogComponent,
        FeaturesAnnouncementEditComponent,
        AdminPortalAccountsComponent,
        AdminPortalCreateAccountComponent,
        AdminPortalModifyAccountComponent,
        SearchFilterPipe,
        AdminPortalUserLogsComponent,
        ReportsBranchComissionComponent,
        ReportsSummaryComponent,
        ReportsTopUserComponent,
        ReportsComponent,
        ReportsDailySalesComponent,
        ReportsReferalComissionComponent,
        SkuCashInComponent,
        SkuCashInEditComponent,
        SendPassComponent,    
        CustomCategoryComponent,
        ActionDialogComponent,
        FeaturesPushNotifEditComponent,
        ImagePreviewDialogComponent,
        ViewReferalComponent,
        AdminPortalAccountModalComponent,
        AdminPortalAccountsOldComponent,
        AppMaintainanceComponent,
        FeaturesByTiersComponent,
        ModifyTierModalComponent,
        FeaturesRdpdDashboardComponent,
        ViewDistributorsComponent,
        AddDistributorComponent,
        CreateEditSkuModalComponent,
        CreateEditAdsModalComponent,
        AccessDeniedComponent
        // AccountsSearchComponent,
        // AdminPortalAccountsExpandComponent,
        // ExpansionComponent,
        // AdminPortalUserLogsComponent,
        // ReportsSummaryComponent,
        // ReportsDailySalesComponent,
        // ReportsTopUserComponent,
        // ReportsReferalComissionComponent,
        // ReportsBranchComissionComponent,
        // ReportsComponent,
        // AdminPortalAccountsComponent,
        // FeaturesAnnouncementEditComponent,
        // ForTESTComponent,
        // ComponentSkuBillerAllTransactionEditComponent,
        // SkuBillerAllTransactionEditComponent,
        // SkuStoresEditComponent,
        // SkuPaybillsEditComponent
    ],
    exports: [BrowserAnimationsModule],
    bootstrap: [AppComponent], 
    imports: [
        NgxSpinnerModule,
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        LoginPageModule,
        MaterialModule,
        FormsModule,
        // Ng2SearchPipeModule,
        // NgxPaginationModule,
        ReactiveFormsModule,
        MatDialogModule,
        NgxSmartModalModule.forRoot(),
        ToastrModule.forRoot({
            timeOut: 5000,
            positionClass: 'toast-top-right'
        }),
        TemplateComponent,
        SidenavComponent,
        HeaderComponent,
        MegaRewardComponent,
        OverviewComponent,
        SkuPaybillsEditComponent,
        SkuStoresEditComponent,
        AdminBuyloadComponent,
        AdminTpPayBillsComponent,
        AdminTpCashInComponent,
        AdminTpStoresComponent,
        AdminTpRedeemComponent,
        SkuStoresComponent,
        SkuRedeemComponent,
        SkuDisbursementComponent,
        AllTransactionComponent,
        TransferFundsComponent,
        StorePurchaseComponent,
        AccountsEditComponent,
        AccountsComponent,
        DropdownFieldComponent,
        DropdownFieldV2Component,
        CustomToggleAddBtnComponent,
        PaginationComponent,
        TableControlsComponent,
        SharedPipeModule,
        SharedDirectivesModule,
        SharedComponentsModule,
        DateInputComponent,
        LimitControlComponent,
        SearchControlComponent,
        DropdownChecklistComponent,
        DropdownChecklistV2Component,
        ToggleableComponent,
        MegapayLoaderComponent,
      ], 
      schemas: [CUSTOM_ELEMENTS_SCHEMA],
      providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
        CurrencyPipe,
        DecimalPipe,
        DatePipe,
        TitleCasePipe,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthInterceptor,
          multi: true
        },
        provideHttpClient(withInterceptorsFromDi()),
        { 
          // initializer for starting the polling and monitoring for auto logout and etc 
          // that needs to be active (this ensure even the page refreshed polling still works b initializing again)
          provide: APP_INITIALIZER,
          useFactory: (
            authService: AuthService,
            idleWatcher: IdleWatcherService,
            userStatusChecker: UserStatusCheckerService,
            rbacService: RbacService,
            toastr: ToastrService
          ) => () => {
            if (authService.isLoggedIn()) {
              const rememberMe = localStorage.getItem('rememberMe') === 'true';
              rbacService.init();    
              idleWatcher.start(rememberMe);
              userStatusChecker.startPolling();
            }
            const pendingToast = sessionStorage.getItem('postReloadToast');
            if (pendingToast) {
              sessionStorage.removeItem('postReloadToast');
              toastr.success(pendingToast);
            }
          },
          deps: [AuthService, IdleWatcherService, UserStatusCheckerService, RbacService, ToastrService],
          multi: true
        }
      ]})
export class AppModule { }
